import {observer} from "mobx-react";
import {Linq, Pager, ScrollTable} from "../../ui";
import {pmsOverviewStore} from "../../../store";
import {useNavigate} from "react-router";

const PmsPrinterList = observer(function PmsPrinterList() {
    const navigate = useNavigate()
    return <>
        <ScrollTable>
            <thead>
            <tr>
                <th>Kurzname</th>
                <th>Netzwerkname</th>
                <th>Nutzungsart</th>
            </tr>
            </thead>
            <tbody>
            {pmsOverviewStore.items.map((val, index) => {
                const link = `/pms/${val.id}`
                return <tr key={index} style={{cursor: 'pointer'}} onClick={() => {
                    navigate(link)
                }}>
                    <td><Linq to={`${link}`}>{val.displayName}</Linq></td>
                    <td><Linq to={`${link}`}>{val.name}</Linq></td>
                    <td><Linq to={`${link}`}>{val.type}</Linq></td>
                </tr>
            })}
            </tbody>
        </ScrollTable>
        <Pager total={pmsOverviewStore.pages}/>
    </>
})

export {
    PmsPrinterList
}
